import type { VariantContent } from "./types";

export interface TopNavContent {
  firstName: string;
  lastName: string;
  domain: string;
}

export const topNavContent: VariantContent<TopNavContent> = {
  uk: {
    domain: "tony.uk",
    firstName: "Tony",
    lastName: "Narlock",
  },
  us: {
    domain: "tony.nl",
    firstName: "Tony",
    lastName: "Narlock",
  },
};
